import { render, staticRenderFns } from "./SearchBox2.vue?vue&type=template&id=f31c7de2&scoped=true&"
import script from "./SearchBox2.vue?vue&type=script&lang=js&"
export * from "./SearchBox2.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox2.vue?vue&type=style&index=0&id=f31c7de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31c7de2",
  null
  
)

export default component.exports